<p ngClass="chip-container" [ngStyle]="getStatusColor()">
    {{ getStatusLabel() | titlecase }}
</p>
